export default {
      id: "icon-prep-usage",
      viewBox: "0 0 157.2 117.7",
      url: __webpack_public_path__ + "icons.svg#icon-prep",
      toString: function () {
        return this.url;
      }
    }